import _get from 'lodash/get'

import { fetchResources, forOwner, forQuery, set } from '../../_stores/_storeMethods'

export default {
  namespaced: true,
  state: {
    collection: _get(window, 'appInitialData.stores.Countries', [])
  },
  mutations: {
    set
  },
  getters: {
    collection: state => state.collection
  }
}
